export const en = {
    'center-bottom': 'Center bottom',
    'center-center': 'Center center',
    'center-top': 'Center top',
    default: '-',
    'left-bottom': 'Left bottom',
    'left-center': 'Left center',
    'left-top': 'Left top',
    'right-bottom': 'Right bottom',
    'right-center': 'Right center',
    'right-top': 'Right top'
};
